/* global $ */
import 'owl.carousel'
import { Controller } from '@hotwired/stimulus'
import './themes_slider_component.scss'

export default class extends Controller {
  connect() {
    const owl = $(this.element)
    owl.owlCarousel({
      margin: 30,
      dots: false,
      reponsiveClass: true,
      responsive: {
        0: {
          items: 2
        },
        768: {
          items: 3
        },
        1000: {
          items: 4
        }
      }
    })

    owl
      .closest('.slider-wrapper')
      .find('.slider-previous')
      .click(() => {
        owl.trigger('prev.owl.carousel')
      })

    owl
      .closest('.slider-wrapper')
      .find('.slider-next')
      .click(() => {
        owl.trigger('next.owl.carousel')
      })
  }
}
